import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const ROLE_CONFIG = {
  '/sirket-giris': { role: 'company', label: 'Şirket Girişi', desc: 'Şirket hesabınıza giriş yapın' },
};

const LoginPage = () => {
  const { login, isLoading, error } = useAuthStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const roleConfig = ROLE_CONFIG[pathname] || { role: 'student', label: 'Staj Platform', desc: 'Hesabınıza giriş yapın' };

  const [form, setForm] = useState({ email: '', password: '' });
  const [step, setStep] = useState('credentials'); // 'credentials' | '2fa'
  const [totpToken, setTotpToken] = useState('');
  const [roleError, setRoleError] = useState('');

  const afterLogin = (result) => {
    // Şirket giriş sayfasından başka role giriş yapılamaz
    if (roleConfig.role === 'company' && result.role !== 'company') {
      setRoleError('Bu giriş sayfası şirketlere özeldir.');
      return;
    }
    if (result.role === 'admin') navigate('/admin');
    else if (result.role === 'company') navigate('/company');
    else navigate('/student');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRoleError('');
    try {
      const result = await login(form.email, form.password);
      if (result?.requires_2fa) { setStep('2fa'); return; }
      afterLogin(result);
    } catch {}
  };

  const handle2FA = async (e) => {
    e.preventDefault();
    setRoleError('');
    try {
      const result = await login(form.email, form.password, totpToken);
      if (result?.requires_2fa) return;
      afterLogin(result);
    } catch {}
  };

  const inputStyle = {
    width: '100%', padding: '10px 14px', border: '1px solid #d1d5db',
    borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box'
  };
  const labelStyle = { display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 };

  return (
    <div style={{
      minHeight: '100vh', background: '#f9fafb',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16
    }}>
      <div style={{
        width: '100%', maxWidth: 400, background: '#fff', borderRadius: 16,
        padding: 'clamp(24px, 5vw, 40px)', boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 8 }}>
          {roleConfig.label}
        </h1>
        <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 28 }}>
          {step === '2fa' ? 'İki faktörlü doğrulama' : roleConfig.desc}
        </p>

        {(error || roleError) && (
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca',
            borderRadius: 8, padding: '10px 14px', marginBottom: 16,
            color: '#dc2626', fontSize: 13
          }}>
            {roleError || error}
          </div>
        )}

        {step === 'credentials' ? (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>E-posta</label>
              <input
                type="email" required style={inputStyle}
                value={form.email}
                onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={labelStyle}>Şifre</label>
              <input
                type="password" required style={inputStyle}
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              />
            </div>
            <button
              type="submit" disabled={isLoading}
              style={{
                width: '100%', padding: '12px', background: isLoading ? '#93c5fd' : '#2563eb',
                color: '#fff', border: 'none', borderRadius: 8,
                fontSize: 15, fontWeight: 500, cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {isLoading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        ) : (
          <form onSubmit={handle2FA}>
            <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '12px 14px', marginBottom: 20, fontSize: 13, color: '#1d4ed8' }}>
              Authenticator uygulamanızdaki 6 haneli kodu girin.
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={labelStyle}>Doğrulama Kodu</label>
              <input
                type="text" maxLength={6} autoFocus
                value={totpToken}
                onChange={e => setTotpToken(e.target.value.replace(/\D/g, ''))}
                placeholder="000000"
                style={{ ...inputStyle, fontSize: 24, letterSpacing: 10, textAlign: 'center' }}
              />
            </div>
            <button
              type="submit" disabled={isLoading || totpToken.length !== 6}
              style={{
                width: '100%', padding: '12px',
                background: (isLoading || totpToken.length !== 6) ? '#93c5fd' : '#2563eb',
                color: '#fff', border: 'none', borderRadius: 8,
                fontSize: 15, fontWeight: 500, cursor: (isLoading || totpToken.length !== 6) ? 'not-allowed' : 'pointer'
              }}
            >
              {isLoading ? 'Doğrulanıyor...' : 'Doğrula ve Giriş Yap'}
            </button>
            <button
              type="button" onClick={() => { setStep('credentials'); setTotpToken(''); }}
              style={{ width: '100%', marginTop: 10, padding: '10px', background: 'none', border: 'none', color: '#6b7280', fontSize: 13, cursor: 'pointer' }}
            >
              ← Geri dön
            </button>
          </form>
        )}

        {step === 'credentials' && (
          <div style={{ marginTop: 20, textAlign: 'center' }}>
            {roleConfig.role === 'student' && (
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>
                Hesabınız yok mu?{' '}
                <Link to="/register" style={{ color: '#2563eb', fontWeight: 500 }}>Kayıt Ol</Link>
              </p>
            )}
            {roleConfig.role === 'company' && (
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>
                Hesabınız yok mu?{' '}
                <Link to="/sirket-kayit" style={{ color: '#2563eb', fontWeight: 500 }}>Kayıt Ol</Link>
              </p>
            )}
            <Link to="/forgot-password" style={{ fontSize: 13, color: '#6b7280' }}>
              Şifremi unuttum
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
